<template>
  <div>
    <div class="deliveryVisual">
      <div class="titArea">
        <h2 class="titH3 normal">
          이제 웰몰 정기배송으로
          <br />
          편리하게 배송받자!
        </h2>
      </div>
      <ul class="deliveryVisualLink">
        <li>
          <a href="#link">
            <span>정기배송</span>
            이용 가이드
          </a>
        </li>
        <li>
          <a href="#link">
            <span>정기배송</span>
            FAQ
          </a>
        </li>
      </ul>
      <div class="btnArea">
        <button type="button" class="btn_p">
          정기배송 서비스의 프리미엄 혜택
          <i></i>
        </button>
      </div>
    </div>

    <span class="stickyPoint t1"></span>
    <!-- header가 올라가는 시점 -->

    <section class="hr full">
      <div class="banner slide fraction" id="slide1">
        <ul class="slideList">
          <li>
            <a href="#link">
              <span class="img">
                <img src="@/../static/img/mw/temp/temp_banner_promotion01.png" alt="해시태그 이벤트! #이벤트 참여 #스벅쿠폰증정" />
              </span>
            </a>
          </li>
          <li>
            <a href="#link">
              <span class="img">
                <img src="@/../static/img/mw/temp/temp_banner_promotion02.png" alt="해시태그 이벤트! #이벤트 참여 #스벅쿠폰증정" />
              </span>
            </a>
          </li>
          <li>
            <a href="#link">
              <span class="img">
                <img src="@/../static/img/mw/temp/temp_banner_promotion02.png" alt="해시태그 이벤트! #이벤트 참여 #스벅쿠폰증정" />
              </span>
            </a>
          </li>
        </ul>
      </div>
    </section>

    <section class="full hr">
      <div class="sortArea filter">
        <div class="lcont">
          <span class="txt">
            총
            <em>9,999</em>
            개
          </span>
        </div>
        <div class="rcont">
          <select class="btnTxt_sort" title="상품정렬 선택">
            <option value="" selected="selected">인기순</option>
            <option value="">신상품순</option>
            <option value="">최고가순</option>
            <option value="">최저가순</option>
          </select>
          <button type="button" class="btnTxt_filter"><span>상세필터</span></button>
        </div>
      </div>

      <ul class="prdList">
        <li>
          <div class="block">
            <div class="prdItem">
              <div class="imgArea">
                <a href="#link" class="img"><img src="@/../static/img/mw/temp/temp_product03.png" alt="NEW 웰릭스 음식물처리기 DK-W2020" /></a>
              </div>
              <div class="infoArea">
                <a href="#link" class="tit row2">
                  <span>[바이오티크] 천연 올인원 샴푸 190ml 마르고사 (각질제거/볼륨윤기/PH밸 [웰치] 전기레인지 JWI2600 BLACK99</span>
                </a>
                <div class="prdPrice">
                  <div class="row">
                    <span class="info">
                      1회 구매
                      <span class="badge gray">
                        <span>5</span>
                        %
                      </span>
                    </span>
                    <div class="val">
                      <span class="del">
                        <span>21,000</span>
                        원
                      </span>
                      <br />
                      <span class="price">
                        <em class="money">17,789</em>
                        원
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <span class="info">
                      정기배송
                      <span class="badge">
                        <span>17</span>
                        %
                      </span>
                    </span>
                    <div class="val">
                      <span class="price">
                        <em class="money">16,900</em>
                        원
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <span class="info txtXXS pointC1">제휴카드가</span>
                    <div class="val">
                      <span class="price pointC1">
                        <em class="money">3,900</em>
                        원
                      </span>
                    </div>
                  </div>
                </div>

                <ul class="utilBtn">
                  <li>
                    <a href="#link" class="icoBtn zzim on">
                      <span>
                        찜 (
                        <i>9,999</i>
                        )
                      </span>
                    </a>
                    <!-- 클래스 on -->
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="block">
            <div class="prdItem">
              <div class="imgArea">
                <a href="#link" class="img"><img src="@/../static/img/mw/temp/temp_product03.png" alt="NEW 웰릭스 음식물처리기 DK-W2020" /></a>
              </div>
              <div class="infoArea">
                <a href="#link" class="tit row2">
                  <span>[바이오티크] 천연 올인원 샴푸 190ml 마르고사 (각질제거/볼륨윤기/PH밸 [웰치] 전기레인지 JWI2600 BLACK99</span>
                </a>
                <div class="prdPrice">
                  <div class="row">
                    <span class="info">
                      1회 구매
                      <span class="badge gray">
                        <span>40</span>
                        %
                      </span>
                    </span>
                    <div class="val">
                      <span class="del">
                        <span>15,000</span>
                        원
                      </span>
                      <br />
                      <span class="price">
                        <em class="money">9,473</em>
                        원
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <span class="info">
                      정기배송
                      <span class="badge">
                        <span>43</span>
                        %
                      </span>
                    </span>
                    <div class="val">
                      <span class="price">
                        <em class="money">9,000</em>
                        원
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <span class="info txtXXS pointC1">제휴카드가</span>
                    <div class="val">
                      <span class="price pointC1">
                        <em class="money">0</em>
                        원
                      </span>
                    </div>
                  </div>
                </div>

                <ul class="utilBtn">
                  <li>
                    <a href="#link" class="icoBtn zzim">
                      <span>
                        찜 (
                        <i>9,999</i>
                        )
                      </span>
                    </a>
                    <!-- 클래스 on -->
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="block">
            <div class="prdItem">
              <div class="imgArea">
                <a href="#link" class="img"><img src="@/../static/img/mw/temp/temp_product03.png" alt="NEW 웰릭스 음식물처리기 DK-W2020" /></a>
              </div>
              <div class="infoArea">
                <a href="#link" class="tit row2">
                  <span>[바이오티크] 천연 올인원 샴푸 190ml 마르고사 (각질제거/볼륨윤기/PH밸 [웰치] 전기레인지 JWI2600 BLACK99</span>
                </a>
                <div class="prdPrice">
                  <div class="row">
                    <span class="info">
                      1회 구매
                      <span class="badge gray">
                        <span>47</span>
                        %
                      </span>
                    </span>
                    <div class="val">
                      <span class="del">
                        <span>150,000</span>
                        원
                      </span>
                      <br />
                      <span class="price">
                        <em class="money">78,842</em>
                        원
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <span class="info">
                      정기배송
                      <span class="badge">
                        <span>50</span>
                        %
                      </span>
                    </span>
                    <div class="val">
                      <span class="price">
                        <em class="money">74,900</em>
                        원
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <span class="info txtXXS pointC1">제휴카드가</span>
                    <div class="val">
                      <span class="price pointC1">
                        <em class="money">61,000</em>
                        원
                      </span>
                    </div>
                  </div>
                </div>

                <ul class="utilBtn">
                  <li>
                    <a href="#link" class="icoBtn zzim">
                      <span>
                        찜 (
                        <i>9,999</i>
                        )
                      </span>
                    </a>
                    <!-- 클래스 on -->
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="block">
            <div class="prdItem">
              <div class="imgArea">
                <a href="#link" class="img"><img src="@/../static/img/mw/temp/temp_product03.png" alt="NEW 웰릭스 음식물처리기 DK-W2020" /></a>
              </div>
              <div class="infoArea">
                <a href="#link" class="tit row2">
                  <span>[바이오티크] 천연 올인원 샴푸 190ml 마르고사 (각질제거/볼륨윤기/PH밸 [웰치] 전기레인지 JWI2600 BLACK99</span>
                </a>
                <div class="prdPrice">
                  <div class="row">
                    <span class="info">
                      1회 구매
                      <span class="badge gray">
                        <span>47</span>
                        %
                      </span>
                    </span>
                    <div class="val">
                      <span class="del">
                        <span>150,000</span>
                        원
                      </span>
                      <br />
                      <span class="price">
                        <em class="money">78,842</em>
                        원
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <span class="info">
                      정기배송
                      <span class="badge">
                        <span>50</span>
                        %
                      </span>
                    </span>
                    <div class="val">
                      <span class="price">
                        <em class="money">74,900</em>
                        원
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <span class="info txtXXS pointC1">제휴카드가</span>
                    <div class="val">
                      <span class="price pointC1">
                        <em class="money">61,000</em>
                        원
                      </span>
                    </div>
                  </div>
                </div>

                <ul class="utilBtn">
                  <li>
                    <a href="#link" class="icoBtn zzim">
                      <span>
                        찜 (
                        <i>9,999</i>
                        )
                      </span>
                    </a>
                    <!-- 클래스 on -->
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="block">
            <div class="prdItem">
              <div class="imgArea">
                <a href="#link" class="img"><img src="@/../static/img/mw/temp/temp_product03.png" alt="NEW 웰릭스 음식물처리기 DK-W2020" /></a>
              </div>
              <div class="infoArea">
                <a href="#link" class="tit row2">
                  <span>[바이오티크] 천연 올인원 샴푸 190ml 마르고사 (각질제거/볼륨윤기/PH밸 [웰치] 전기레인지 JWI2600 BLACK99</span>
                </a>
                <div class="prdPrice">
                  <div class="row">
                    <span class="info">
                      1회 구매
                      <span class="badge gray">
                        <span>47</span>
                        %
                      </span>
                    </span>
                    <div class="val">
                      <span class="del">
                        <span>150,000</span>
                        원
                      </span>
                      <br />
                      <span class="price">
                        <em class="money">78,842</em>
                        원
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <span class="info">
                      정기배송
                      <span class="badge">
                        <span>50</span>
                        %
                      </span>
                    </span>
                    <div class="val">
                      <span class="price">
                        <em class="money">74,900</em>
                        원
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <span class="info txtXXS pointC1">제휴카드가</span>
                    <div class="val">
                      <span class="price pointC1">
                        <em class="money">61,000</em>
                        원
                      </span>
                    </div>
                  </div>
                </div>

                <ul class="utilBtn">
                  <li>
                    <a href="#link" class="icoBtn zzim">
                      <span>
                        찜 (
                        <i>9,999</i>
                        )
                      </span>
                    </a>
                    <!-- 클래스 on -->
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="block">
            <div class="prdItem">
              <div class="imgArea">
                <a href="#link" class="img"><img src="@/../static/img/mw/temp/temp_product03.png" alt="NEW 웰릭스 음식물처리기 DK-W2020" /></a>
              </div>
              <div class="infoArea">
                <a href="#link" class="tit row2">
                  <span>[바이오티크] 천연 올인원 샴푸 190ml 마르고사 (각질제거/볼륨윤기/PH밸 [웰치] 전기레인지 JWI2600 BLACK99</span>
                </a>
                <div class="prdPrice">
                  <div class="row">
                    <span class="info">
                      1회 구매
                      <span class="badge gray">
                        <span>47</span>
                        %
                      </span>
                    </span>
                    <div class="val">
                      <span class="del">
                        <span>150,000</span>
                        원
                      </span>
                      <br />
                      <span class="price">
                        <em class="money">78,842</em>
                        원
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <span class="info">
                      정기배송
                      <span class="badge">
                        <span>50</span>
                        %
                      </span>
                    </span>
                    <div class="val">
                      <span class="price">
                        <em class="money">74,900</em>
                        원
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <span class="info txtXXS pointC1">제휴카드가</span>
                    <div class="val">
                      <span class="price pointC1">
                        <em class="money">61,000</em>
                        원
                      </span>
                    </div>
                  </div>
                </div>

                <ul class="utilBtn">
                  <li>
                    <a href="#link" class="icoBtn zzim">
                      <span>
                        찜 (
                        <i>9,999</i>
                        )
                      </span>
                    </a>
                    <!-- 클래스 on -->
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="block">
            <div class="prdItem">
              <div class="imgArea">
                <a href="#link" class="img"><img src="@/../static/img/mw/temp/temp_product03.png" alt="NEW 웰릭스 음식물처리기 DK-W2020" /></a>
              </div>
              <div class="infoArea">
                <a href="#link" class="tit row2">
                  <span>[바이오티크] 천연 올인원 샴푸 190ml 마르고사 (각질제거/볼륨윤기/PH밸 [웰치] 전기레인지 JWI2600 BLACK99</span>
                </a>
                <div class="prdPrice">
                  <div class="row">
                    <span class="info">
                      1회 구매
                      <span class="badge gray">
                        <span>47</span>
                        %
                      </span>
                    </span>
                    <div class="val">
                      <span class="del">
                        <span>150,000</span>
                        원
                      </span>
                      <br />
                      <span class="price">
                        <em class="money">78,842</em>
                        원
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <span class="info">
                      정기배송
                      <span class="badge">
                        <span>50</span>
                        %
                      </span>
                    </span>
                    <div class="val">
                      <span class="price">
                        <em class="money">74,900</em>
                        원
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <span class="info txtXXS pointC1">제휴카드가</span>
                    <div class="val">
                      <span class="price pointC1">
                        <em class="money">61,000</em>
                        원
                      </span>
                    </div>
                  </div>
                </div>

                <ul class="utilBtn">
                  <li>
                    <a href="#link" class="icoBtn zzim">
                      <span>
                        찜 (
                        <i>9,999</i>
                        )
                      </span>
                    </a>
                    <!-- 클래스 on -->
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import * as customjs from '@/../static/js/m.front';
export default {
  name: 'DeliveryMain',
  mounted() {
    customjs.addStiky('.sortArea.filter');
    customjs.slideInit('#slide1', 5000, false, 300, true, 1, 0, 'fraction');
  },
};
</script>
